// This file is auto-generated by @hey-api/openapi-ts

export type ClientOptions = {
    baseUrl: 'https://spk-sil-nds-d-app-wa-shop-be.azurewebsites.net' | (string & {});
};

/**
 * Favorite list item with last order metadata
 */
export type FavoriteListItemDto = {
    /**
     * Product identifier
     */
    productId?: string;
    /**
     * Date of last order for this product in this list
     */
    lastOrderDate?: string;
    /**
     * Quantity of last order for this product in this list
     */
    lastOrderQuantity?: number;
    /**
     * Desired quantity saved by user for this product in this list
     */
    desiredQuantity?: number;
};

/**
 * Favorite list response including items
 */
export type FavoriteListResponseDto = {
    /**
     * Unique identifier of the favorite list
     */
    id?: string;
    /**
     * Favorite list name
     */
    name?: string;
    /**
     * Identifier of the customer who owns the list
     */
    customerId?: string;
    /**
     * Favorite list items with last order metadata
     */
    items?: Array<FavoriteListItemDto>;
    /**
     * Creation timestamp of the favorite list
     */
    creationDate?: string;
    /**
     * Identifier of the creator actor
     */
    createdBy?: string;
    /**
     * Last modification timestamp of the favorite list
     */
    lastModifiedDate?: string;
    /**
     * Identifier of the actor who last modified the list
     */
    lastModifiedBy?: string;
    default?: boolean;
};

/**
 * Request payload to set desired quantity for a product in a favorite list
 */
export type DesiredQuantityRequestDto = {
    /**
     * Desired quantity to save for the product. Use null to clear.
     */
    desiredQuantity?: number;
};

export type FavoriteListEditRquestDto = {
    name: string;
};

export type BaseOptionDto = {
    code?: string;
    name?: string;
};

export type CategoryDto = {
    code?: string;
    name?: string;
};

export type ClassificationDto = {
    code?: string;
    name?: string;
};

/**
 * Representation of the sales unit
 */
export type ConversionDto = {
    unit?: string;
    factor?: string;
};

/**
 * Representation of a Future Stock
 */
export type FutureStockDto = {
    stock?: StockDto;
    /**
     * Date of future stock
     */
    date?: string;
    /**
     * Date of future stock expressed in text value
     */
    formattedDate?: string;
};

export type ImageDto = {
    imageType?: ImageTypeEnum;
    /**
     * Format of the image, can be zoom, product, thumbnail, store, cartIcon, etc.
     */
    format?: string;
    /**
     * URL address of the image
     */
    url?: string;
    /**
     * Tooltip content which is visible while image mouse hovering
     */
    altText?: string;
    galleryIndex?: number;
};

export type MediqClassificationDto = {
    code?: string;
    values?: Array<string>;
};

export type PaginationDto = {
    /**
     * Page you want to retrieve (0..N)
     */
    page?: number;
    /**
     * Number of records per page.
     */
    pageSize?: number;
    sortBy?: string;
    sortDirection?: SortDirectionEnum;
    totalPages?: number;
    totalResults?: bigint;
};

/**
 * Representation of a Price
 */
export type PriceDto = {
    /**
     * Currency iso format
     */
    currencyIso?: string;
    /**
     * Value of price in BigDecimal format
     */
    value?: number;
    priceType?: PriceTypeEnum;
    /**
     * Value of price formatted
     */
    formattedValue?: string;
    minQuantity?: bigint;
    maxQuantity?: bigint;
    campaignCode?: string;
};

/**
 * Representation of a Price Range
 */
export type PriceRangeDto = {
    maxPrice?: PriceDto;
    minPrice?: PriceDto;
};

export type ProductDocumentDto = {
    name?: string;
    url?: string;
};

export type ProductNonInventoryPartDto = {
    code?: string;
    name?: string;
};

export type ProductReferenceDto = {
    code?: string;
    name?: string;
};

export type ProductSearchFacetMetadataResultDto = {
    type?: TypeEnum;
    priority?: number;
};

export type ProductSearchFacetMetadataResultListDto = {
    category?: ProductSearchFacetMetadataResultDto;
    brand?: ProductSearchFacetMetadataResultDto;
    stockAvailability?: ProductSearchFacetMetadataResultDto;
    size?: ProductSearchFacetMetadataResultDto;
    balloonVolume?: ProductSearchFacetMetadataResultDto;
    carbAmount?: ProductSearchFacetMetadataResultDto;
    ch?: ProductSearchFacetMetadataResultDto;
    color?: ProductSearchFacetMetadataResultDto;
    containsLatex?: ProductSearchFacetMetadataResultDto;
    containsPvc?: ProductSearchFacetMetadataResultDto;
    energyAmount?: ProductSearchFacetMetadataResultDto;
    fatAmount?: ProductSearchFacetMetadataResultDto;
    fiberAmount?: ProductSearchFacetMetadataResultDto;
    material?: ProductSearchFacetMetadataResultDto;
    numberOfWashes?: ProductSearchFacetMetadataResultDto;
    proteinAmount?: ProductSearchFacetMetadataResultDto;
    ceMarkedProduct?: ProductSearchFacetMetadataResultDto;
    bisphenol?: ProductSearchFacetMetadataResultDto;
    lanolin?: ProductSearchFacetMetadataResultDto;
    phthalates?: ProductSearchFacetMetadataResultDto;
    plasticizer?: ProductSearchFacetMetadataResultDto;
    resin?: ProductSearchFacetMetadataResultDto;
    sterile?: ProductSearchFacetMetadataResultDto;
    environmentalCode?: ProductSearchFacetMetadataResultDto;
    absorptionCapacity?: ProductSearchFacetMetadataResultDto;
    taste?: ProductSearchFacetMetadataResultDto;
    tip?: ProductSearchFacetMetadataResultDto;
    tubingLength?: ProductSearchFacetMetadataResultDto;
};

export type ProductSearchFacetResultBooleanDto = {
    value?: boolean;
    hits?: number;
    selected?: boolean;
};

export type ProductSearchFacetResultDto = {
    value?: ProductSearchFacetResultValueDto;
    hits?: number;
    selected?: boolean;
};

export type ProductSearchFacetResultListDto = {
    category?: Array<ProductSearchFacetResultDto>;
    brand?: Array<ProductSearchFacetResultDto>;
    stockAvailability?: Array<ProductSearchFacetResultBooleanDto>;
    size?: Array<ProductSearchFacetResultDto>;
    balloonVolume?: Array<ProductSearchFacetResultDto>;
    carbAmount?: Array<ProductSearchFacetResultDto>;
    ch?: Array<ProductSearchFacetResultDto>;
    color?: Array<ProductSearchFacetResultDto>;
    containsLatex?: Array<ProductSearchFacetResultDto>;
    containsPvc?: Array<ProductSearchFacetResultBooleanDto>;
    energyAmount?: Array<ProductSearchFacetResultDto>;
    fatAmount?: Array<ProductSearchFacetResultDto>;
    fiberAmount?: Array<ProductSearchFacetResultDto>;
    material?: Array<ProductSearchFacetResultDto>;
    numberOfWashes?: Array<ProductSearchFacetResultDto>;
    proteinAmount?: Array<ProductSearchFacetResultDto>;
    ceMarkedProduct?: Array<ProductSearchFacetResultBooleanDto>;
    bisphenol?: Array<ProductSearchFacetResultBooleanDto>;
    lanolin?: Array<ProductSearchFacetResultBooleanDto>;
    phthalates?: Array<ProductSearchFacetResultBooleanDto>;
    plasticizer?: Array<ProductSearchFacetResultBooleanDto>;
    resin?: Array<ProductSearchFacetResultBooleanDto>;
    sterile?: Array<ProductSearchFacetResultBooleanDto>;
    environmentalCode?: Array<ProductSearchFacetResultDto>;
    absorptionCapacity?: Array<ProductSearchFacetResultDto>;
    taste?: Array<ProductSearchFacetResultDto>;
    tip?: Array<ProductSearchFacetResultDto>;
    tubingLength?: Array<ProductSearchFacetResultDto>;
};

export type ProductSearchFacetResultValueDto = {
    id?: string;
    displayName?: string;
};

export type ProductSearchResultDto = {
    results?: Array<SilWebProductDto>;
    facets?: ProductSearchFacetResultListDto;
    facetMetadata?: ProductSearchFacetMetadataResultListDto;
    pagination?: PaginationDto;
};

export type PromotionDto = {
    code?: string;
    title?: string;
    description?: string;
};

export type ReviewDto = {
    id?: string;
    rating?: number;
    comment?: string;
};

/**
 * Representation of a Unit
 */
export type SapUnitDto = {
    /**
     * Code of the unit
     */
    code?: string;
    /**
     * Name of the unit
     */
    name?: string;
    /**
     * Code of the unit is used to check availability
     */
    availabilityCode?: string;
    /**
     * Code of the SAP unit
     */
    sapCode?: string;
};

/**
 * Representation of the sales unit
 */
export type SalesUnitsDto = {
    /**
     * Code of the sales unit
     */
    code?: string;
    /**
     * Name of the sales unit
     */
    defaultSalesUnit?: string;
    /**
     * Description of the sales unit
     */
    salesUnitDescription?: string;
    /**
     * Conversion factor of the sales unit
     */
    conversions?: Array<ConversionDto>;
};

/**
 * Representation of a Product
 */
export type SilWebProductDto = {
    /**
     * Code of the product
     */
    code?: string;
    /**
     * Name of the product
     */
    name?: string;
    lastOrderDate?: string;
    lastOrderQuantity?: number;
    /**
     * User preferred desired quantity for quick order from favorite list
     */
    desiredQuantity?: number;
    /**
     * Url address of the product
     */
    url?: string;
    /**
     * Description of the product
     */
    description?: string;
    /**
     * Flag defining if product is purchasable
     */
    purchasable?: boolean;
    stock?: StockDto;
    /**
     * List of future stocks
     */
    futureStocks?: Array<FutureStockDto>;
    /**
     * Flag defining if product is available for pickup
     */
    availableForPickup?: boolean;
    /**
     * Rating number of average value
     */
    averageRating?: number;
    /**
     * Number of reviews associated with the product
     */
    numberOfReviews?: number;
    /**
     * Product summary
     */
    summary?: string;
    /**
     * Data of product manufacturer
     */
    manufacturer?: string;
    /**
     * Variant type of the product
     */
    variantType?: string;
    price?: PriceDto;
    sapUnit?: SapUnitDto;
    /**
     * Information about base product
     */
    baseProduct?: string;
    /**
     * List of images linked to product
     */
    images?: Array<ImageDto>;
    /**
     * List of categories product belongs to
     */
    categories?: Array<CategoryDto>;
    /**
     * List of reviews associated with the product
     */
    reviews?: Array<ReviewDto>;
    /**
     * List of classifications related to the product
     */
    classifications?: Array<ClassificationDto>;
    /**
     * List of potential promotions related to the product
     */
    potentialPromotions?: Array<PromotionDto>;
    /**
     * List of variant options related to the product
     */
    variantOptions?: Array<VariantOptionDto>;
    /**
     * List of base options related to the product
     */
    baseOptions?: Array<BaseOptionDto>;
    /**
     * Flag stating if volume price should be displayed
     */
    volumePricesFlag?: boolean;
    /**
     * List of volume prices
     */
    volumePrices?: Array<PriceDto>;
    /**
     * List of product references
     */
    productReferences?: Array<ProductReferenceDto>;
    /**
     * List of variant matrixes associated with the product
     */
    variantMatrix?: Array<VariantMatrixElementDto>;
    priceRange?: PriceRangeDto;
    /**
     * Flag stating if product is multidimensional
     */
    multidimensional?: boolean;
    /**
     * Configurator type related to the product
     */
    configuratorType?: string;
    /**
     * Flag stating if product is configurable
     */
    configurable?: boolean;
    /**
     * Tags associated with the product
     */
    tags?: Array<string>;
    /**
     * Flag specifies whether product can be added to cart. When addToCartDisabled=true, the product is not allowed to be added into cart and the reason is explained through sapAddToCartDisabledMessage; when addToCartDisabled=false, the product is allowed to be added into cart.
     */
    sapAddToCartDisabled?: boolean;
    /**
     * Message shows why product can not be added to cart.
     */
    sapAddToCartDisabledMessage?: string;
    firstVariantCode?: string;
    firstVariantImage?: string;
    timedAccessPromotion?: PromotionDto;
    source?: string;
    productType?: string;
    packagingDescription?: string;
    sizeDescription?: string;
    size?: string;
    packageQuantity?: number;
    packageUnit?: string;
    packageSalesUnit?: string;
    basePrice?: PriceDto;
    appropriated?: boolean;
    contracted?: boolean;
    salesUnits?: SalesUnitsDto;
    documents?: Array<ProductDocumentDto>;
    supplierAlternativeAID?: string;
    discountedPrice?: PriceDto;
    volumeDiscountsFlag?: boolean;
    volumeDiscounts?: Array<PriceDto>;
    inFavoriteList?: boolean;
    productDatasheet?: ProductDocumentDto;
    technicalDatasheet?: ProductDocumentDto;
    safetyDatasheet?: ProductDocumentDto;
    brochures?: Array<ProductDocumentDto>;
    userManuals?: Array<ProductDocumentDto>;
    certificates?: Array<ProductDocumentDto>;
    productStock?: ProductStockEnum;
    productWebshopStatus?: ProductWebshopStatusEnum;
    productPartStatus?: ProductPartStatusEnum;
    e6ProductId?: string;
    ceMarking?: boolean;
    ceExpiryDate?: string;
    contentUnit?: string;
    ean?: string;
    mediqClassifications?: Array<MediqClassificationDto>;
    nonInventoryParts?: Array<ProductNonInventoryPartDto>;
    inPositiveList?: boolean;
    limitPerOrder?: number;
};

/**
 * Representation of a Stock
 */
export type StockDto = {
    stockLevelStatus: StockLevelStatusEnum;
    stockLevel: number;
    isValueRounded: boolean;
};

export type VariantMatrixElementDto = {
    code?: string;
    name?: string;
};

export type VariantOptionDto = {
    code?: string;
    name?: string;
};

export type ServerMessageDto = {
    /**
     * More information from servers
     */
    message?: string;
};

export type PageableDto = {
    /**
     * Page you want to retrieve (0..N)
     */
    page?: number;
    /**
     * Number of records per page.
     */
    pageSize?: number;
    sortBy?: string;
    sortDirection?: SortDirectionEnum;
};

export type ProductSearchFacetDto = {
    category?: Array<string>;
    brand?: Array<string>;
    stockAvailability?: Array<boolean>;
    size?: Array<string>;
    balloonVolume?: Array<string>;
    carbAmount?: Array<string>;
    ch?: Array<string>;
    color?: Array<string>;
    containsLatex?: Array<string>;
    containsPvc?: Array<boolean>;
    energyAmount?: Array<string>;
    fatAmount?: Array<string>;
    fiberAmount?: Array<string>;
    material?: Array<string>;
    numberOfWashes?: Array<string>;
    proteinAmount?: Array<string>;
    ceMarkedProduct?: Array<boolean>;
    bisphenol?: Array<boolean>;
    lanolin?: Array<boolean>;
    phthalates?: Array<boolean>;
    plasticizer?: Array<boolean>;
    resin?: Array<boolean>;
    sterile?: Array<boolean>;
    environmentalCode?: Array<string>;
    absorptionCapacity?: Array<string>;
    taste?: Array<string>;
    tip?: Array<string>;
    tubingLength?: Array<string>;
};

export type ProductSearchFilterDto = {
    category?: Array<string>;
    contractIds?: Array<string>;
    priceListIds?: Array<string>;
};

/**
 * Product search
 */
export type ProductSearchQueryDto = {
    query?: string;
    displayLocation?: string;
    /**
     * This filed is used for anonymous users to send their unique identifier from cookie. Will fall back to 'anonymous' in case this is not sent
     */
    user?: string;
    facets?: ProductSearchFacetDto;
    filters?: ProductSearchFilterDto;
    pageable?: PageableDto;
};

export type QuickSearchResultDto = {
    products?: Array<SilWebProductDto>;
    categories?: Array<ProductSearchFacetResultDto>;
};

/**
 * Quick search
 */
export type QuickSearchQueryDto = {
    query: string;
    displayLocation?: string;
    /**
     * Unique identifier of an anonymous user, taken from a cookie. Falls back to 'anonymous' when not sent
     */
    user?: string;
};

export type DiscountAppliedDto = {
    /**
     * discount id
     */
    id?: string;
    percentage?: number;
    fixPrice?: number;
    minimumQuantityNeeded?: number;
    quantityOrdered?: number;
    minimumApplicableQuantity?: number;
    discountSourceId?: string;
    startDate?: string;
    endDate?: string;
    discountRowType?: DiscountRowTypeEnum;
    assortmentNode?: string;
    isNettable?: boolean;
    isApplied?: boolean;
};

export type PriceValueDto = {
    productId?: string;
    quantity?: number;
    value?: number;
    valueWithVat?: number;
    totalValue?: number;
    totalValueWithVat?: number;
    fullValue?: number;
    fullValueWithVat?: number;
    fullTotalValue?: number;
    fullTotalValueWithVat?: number;
    vatPercentage?: number;
    currency?: string;
    discountAppliedId?: string;
    netto?: boolean;
    priorityPrice?: boolean;
    priceType?: PriceTypeEnum2;
    discountRowType?: DiscountRowTypeEnum;
    smallestUnitPrice?: SmallestUnitPriceDto;
    /**
     * Applied discounts for this price
     */
    discountApplied?: Array<DiscountAppliedDto>;
};

export type ProductPriceDto = {
    productId?: string;
    quantity?: number;
    /**
     * Valid prices for given product/quantity
     */
    validPrices?: Array<PriceValueDto>;
};

export type ProductsPriceResponseDto = {
    siteId?: string;
    /**
     * Calculated prices for requested products. this will return only priority prices with all possible discounts from other filtered prices for the product
     */
    validPrices?: Array<PriceValueDto>;
    /**
     * Check validPrices in this same ProductsPriceResponseDto. It will return ONLY priority price per product that must be used, instead of this list per product. This will be removed ASAP when FE do their changes.
     *
     * @deprecated
     */
    productPrices?: Array<ProductPriceDto>;
};

export type SmallestUnitPriceDto = {
    /**
     * unit name
     */
    unitName?: string;
    unitPrice?: number;
    unitPriceWithVat?: number;
};

export type BffPriceInputDto = {
    /**
     * DEPRECATED: will be removed in a future version. Value is taken from customer context.
     *
     * @deprecated
     */
    siteId?: string;
    /**
     * @deprecated
     */
    currency?: string;
    products?: Array<ProductPriceLineInputDto>;
};

export type ProductPriceLineInputDto = {
    /**
     * Product identifier
     */
    productId: string;
    /**
     * Quantity to calculate price for
     */
    quantity: number;
};

export type OrderSummaryDto = {
    id: string;
    clientOrderId: string;
    customerOrderRef?: string;
    creationDate: string;
    wantedDeliveryDate: string;
    status: StatusEnum;
    invoices: Array<string>;
    totalGrossAmount: number;
    totalNetAmount: number;
};

export type OrderSummaryListDto = {
    results: Array<OrderSummaryDto>;
    pagination: PaginationDto;
};

export type HistoryQueryDto = {
    orderHistoryQuery?: OrderHistoryQueryDto;
    pagination?: PageableDto;
};

export type OrderHistoryQueryDto = {
    productId?: string;
    orderId?: string;
    customerRef?: string;
    dateFrom?: string;
    dateTo?: string;
};

export type DeliveryAddressDto = {
    addressLine1: string;
    addressLine2?: string;
    countryCode: string;
    name: string;
    zipCode: string;
    entryCode?: string;
    city: string;
    sourceAddressId?: string;
};

export type InputOrderLineDto = {
    productId: string;
    originalProductId?: string;
    appropriationId?: string;
    quantity: number;
};

/**
 * Order to be created
 */
export type UpsertOrderInputDto = {
    clientOrderId: string;
    customerId: string;
    wantedDeliveryDate?: string;
    contract?: string;
    note?: string;
    externalLabelNote?: string;
    shipViaCode?: string;
    entryCode?: string;
    currency?: string;
    customerOrderRef?: string;
    paymentMethod?: PaymentMethodEnum;
    paymentHandle?: string;
    orderType?: OrderTypeEnum;
    paymentTransactionNo?: string;
    parcelLockerId?: string;
    deliveryAddressId?: string;
    phone?: string;
    email?: string;
    orderSource?: OrderSourceEnum;
    webShopUser?: string;
    webShopUserRef?: string;
    orderLines: Array<InputOrderLineDto>;
    deliveryAddress?: DeliveryAddressDto;
};

export type MarketingPermissionDto = {
    permissionGiven?: boolean;
};

/**
 * Update marketing permissions
 */
export type MarketingPermissionRequestDto = {
    permissionGiven?: boolean;
    customerId?: string;
    phone?: string;
    customerType?: CustomerTypeEnum;
};

/**
 * Response wrapper containing product ID and associated favorite list IDs
 */
export type FavoriteListIdsResponseDto = {
    /**
     * The product ID
     */
    productIds?: string;
    /**
     * List of favorite list IDs containing the product
     */
    favoriteListIds?: Array<string>;
};

/**
 * Request wrapper containing a list of product IDs
 */
export type ProductIdsRequestDto = {
    /**
     * List of product IDs to add or process
     */
    productIds?: Array<string>;
};

/**
 * FavoriteListEntity as persisted in the database (without items)
 */
export type FavoriteListEntityDto = {
    /**
     * Unique identifier of the favorite list
     */
    id?: string;
    /**
     * Favorite list name
     */
    name?: string;
    /**
     * Identifier of the customer who owns the list
     */
    customerId?: string;
    /**
     * Whether this list is the default list for the customer
     */
    isDefault?: boolean;
    /**
     * Creation timestamp of the favorite list
     */
    creationDate?: string;
    /**
     * Identifier of the creator actor
     */
    createdBy?: string;
    /**
     * Username of the creator actor
     */
    createdByUsername?: string;
    /**
     * Last modification timestamp of the favorite list
     */
    lastModifiedDate?: string;
    /**
     * Identifier of the actor who last modified the list
     */
    lastModifiedBy?: string;
    /**
     * Username of the actor who last modified the list
     */
    lastModifiedByUsername?: string;
};

export type FavoriteListsListDto = {
    results?: Array<FavoriteListEntityDto>;
    pagination?: PaginationDto;
};

/**
 * Search, sorting and pagination for favorite lists
 */
export type FavoriteListsSearchQueryDto = {
    /**
     * Pagination parameters
     */
    pageable?: PageableWithSortOption;
    /**
     * Filter query for listName
     */
    searchQuery?: string;
    /**
     * Filter query for createdBy
     */
    searchCreatedBy?: string;
};

/**
 * Pagination with sortBy constrained to supported SortOption values
 */
export type PageableWithSortOption = {
    /**
     * Page you want to retrieve (0..N)
     */
    page?: number;
    /**
     * Number of records per page
     */
    pageSize?: number;
    sortBy?: SortByEnum;
};

/**
 * Favorite list with full product data and pagination
 */
export type FavoriteListResponseFullDto = {
    /**
     * Unique identifier of the favorite list
     */
    id?: string;
    /**
     * Favorite list name
     */
    name?: string;
    /**
     * Identifier of the customer who owns the list
     */
    customerId?: string;
    /**
     * Full product data for the current page when using the /full endpoint
     */
    products?: Array<SilWebProductDto>;
    /**
     * Pagination metadata for the /full endpoint
     */
    pagination?: PaginationDto;
    /**
     * Creation timestamp of the favorite list
     */
    creationDate?: string;
    /**
     * Identifier of the creator actor
     */
    createdBy?: string;
    /**
     * Last modification timestamp of the favorite list
     */
    lastModifiedDate?: string;
    /**
     * Identifier of the actor who last modified the list
     */
    lastModifiedBy?: string;
    default?: boolean;
};

/**
 * Query parameters for fetching full favorite list with filtering, sorting and pagination
 */
export type FavoriteListFullSearchQueryDto = {
    /**
     * Pagination parameters
     */
    pageable?: PageableWithSortOptionFull;
    /**
     * Filter query by product name, SKU/number (contains, case-insensitive)
     */
    searchQuery?: string;
    /**
     * Filter by top-level category terms (code or name, case-insensitive contains). Any term may match.
     */
    topLevelCategory?: Array<string>;
    /**
     * Filter by manufacturer/brand terms (contains, case-insensitive). Any term may match.
     */
    brand?: Array<string>;
    /**
     * Filter by size terms (contains, case-insensitive). Any term may match (size or sizeDescription).
     */
    size?: Array<string>;
};

/**
 * Pagination with sortBy constrained to supported SortOption values
 */
export type PageableWithSortOptionFull = {
    /**
     * Page you want to retrieve (0..N)
     */
    page?: number;
    /**
     * Number of records per page
     */
    pageSize?: number;
    sortBy?: SortByEnum2;
};

/**
 * Request body for creating a new favorite list.
 */
export type FavoriteListCreateRequestDto = {
    /**
     * Favorite list name
     */
    name?: string;
    /**
     * List of product ids to initially include
     */
    productIds?: Array<string>;
};

export type CheckoutShippingMethodDto = {
    supplyChainPartGroup?: string;
    pickingLeadtime?: number;
    site?: string;
    shipViaCode?: string;
    routeId?: string;
    defaultShipVia?: boolean;
    deliveryLeadtime?: number;
};

export type CommMethodDto = {
    method?: MethodEnum;
    isDefault?: boolean;
    isAddressDefault?: boolean;
    value?: string;
};

export type CustomerAddressDto = {
    id?: string;
    name?: string;
    addressLine1?: string;
    addressLine2?: string;
    addressLine3?: string;
    addressLine4?: string;
    addressLine5?: string;
    addressLine6?: string;
    postalCode?: string;
    entryCode?: string;
    city?: string;
    countryCode?: string;
    regionCode?: string;
    districtCode?: string;
    formatedAddress?: string;
    shippingCostCode?: string;
    commMethods?: Array<CommMethodDto>;
    usage?: Array<CustomerAddressUsageDto>;
    shippingMethods?: Array<ShippingMethodDto>;
    shippingMethodExceptions?: Array<ShippingMethodExceptionDto>;
    checkoutShippingMethods?: Array<CheckoutShippingMethodDto>;
};

export type CustomerAddressUsageDto = {
    isDefault?: boolean;
    purpose?: PurposeEnum;
};

export type CustomerAddressesResponseDto = {
    addresses?: Array<CustomerAddressDto>;
};

export type ShippingMethodDto = {
    pickingLeadtime?: number;
    site?: string;
    shipViaCode?: string;
    routeId?: string;
    defaultShipVia?: boolean;
    deliveryLeadtime?: number;
};

export type ShippingMethodExceptionDto = {
    supplyChaingPartGroup?: string;
    pickingLeadtime?: number;
    site?: string;
    shipViaCode?: string;
    routeId?: string;
    defaultShipVia?: boolean;
    deliveryLeadtime?: number;
};

/**
 * Customer address to be created/updated
 */
export type CustomerAddressInputDto = {
    id?: string;
    name?: string;
    addressLine1?: string;
    addressLine2?: string;
    postalCode?: string;
    entryCode?: string;
    city?: string;
    shippingCostCode?: string;
    commMethods?: Array<CommMethodDto>;
    usage?: Array<CustomerAddressUsageDto>;
};

/**
 * Retrieves addresses for given customer
 */
export type CustomerAddressesQueryDto = {
    addressType?: PurposeEnum;
    defaultAddressType?: DefaultAddressTypeEnum;
};

export type CalculateCartResponseDto = {
    total?: number;
    totalWithVat?: number;
    delivery?: number;
    deliveryWithVat?: number;
    deliveryChargeSource?: string;
    cartTotal?: number;
    cartTotalWithVat?: number;
    availableDeliveryDates?: Array<string>;
    lines?: Array<CartLineDto>;
};

export type CartLineDiscountAppliedDto = {
    id?: string;
    value?: number;
    valueWithVat?: number;
    use?: UseEnum;
};

export type CartLineDto = {
    unitPrice?: number;
    unitPriceWithVat?: number;
    total?: number;
    totalWithVat?: number;
    fullUnitPrice?: number;
    fullUnitPriceWithVat?: number;
    fullTotal?: number;
    fullTotalWithVat?: number;
    vatPercentage?: number;
    discountAppliedId?: string;
    netto?: boolean;
    currency?: string;
    priceType?: PriceTypeEnum2;
    discountRowType?: DiscountRowTypeEnum;
    productId?: string;
    quantity?: number;
    discountApplied?: CartLineDiscountAppliedDto;
    smallestUnitPrice?: SmallestUnitPriceDto;
};

/**
 * Request body for cart calculation
 */
export type CalculateCartInputDto = {
    businessType?: BusinessTypeEnum;
    /**
     * DEPRECATED: will be removed in a future version. Value is taken from customer context.
     */
    siteId?: string;
    currency: string;
    deliveryAddressId?: string;
    shipViaCode?: string;
    lines: Array<CalculateCartLineInputDto>;
};

export type CalculateCartLineInputDto = {
    productId: string;
    quantity: number;
};

export type AppropriationDto = {
    id?: string;
    source?: string;
    sourceId?: string;
    appropriationId?: string;
    prescriptionType?: PrescriptionTypeEnum;
    quoteType?: boolean;
    customerQuoNo?: string;
    contract?: string;
    mediqFlag?: MediqFlagEnum;
    quotationId?: string;
    customerId?: string;
    validFrom?: string;
    validTo?: string;
    prescriber?: string;
    payingCustomerId?: string;
    agreementGroupId?: string;
    renewable?: boolean;
    comment?: string;
    state?: StateEnum;
    lines?: Array<AppropriationLineDto>;
};

export type AppropriationLineDto = {
    productPrice?: unknown;
    product?: SilWebProductDto;
    lineId?: string;
    releaseId?: string;
    productId: string;
    productType?: ProductTypeEnum;
    buyQuantity: number;
    isOriginalPrescriptionLine?: boolean;
    period?: PeriodEnum;
    periodFrequency?: number;
    remainingQuantity?: number;
    status?: StatusEnum2;
    startDate?: string;
    endDate?: string;
    uom?: string;
    paymentRule?: number;
    isUnlimited?: boolean;
};

export type AppropriationListDto = {
    results?: Array<AppropriationDto>;
    pagination?: PaginationDto;
};

export type AppropriationSearchQueryDto = {
    productIds?: Array<string>;
    productGroups?: Array<string>;
    appropriationStates?: Array<StateEnum>;
    lineStatuses?: Array<StatusEnum2>;
};

/**
 * Get appropriations by given criteria
 */
export type AppropriationSearchRequestDto = {
    appropriationSearchQuery?: AppropriationSearchQueryDto;
    pagination?: PageableDto;
};

export type PositiveListResponseDto = {
    agreementId?: string;
    results?: Array<SilWebProductDto>;
    pagination?: PaginationDto;
};

/**
 * Get customer positive list
 */
export type PositiveListSearchQueryDto = {
    /**
     * DEPRECATED: will be removed in a future version. Value is taken from customer context.
     */
    siteId?: string;
    pagination?: PaginationDto;
};

export type UserInfoDto = {
    id?: string;
    customerId?: string;
    firstName?: string;
    lastName?: string;
    displayUid?: string;
    name?: string;
    type?: string;
};

export type AnonymousTokenResponseDto = {
    /**
     * Anonymous access token
     */
    token?: string;
};

export type DeliveryNoteDto = {
    deliveryNoteNo?: string;
    fileName?: string;
};

export type InvoiceLineDto = {
    invoiceNo?: string;
    fileName?: string;
};

export type OrderDto = {
    id: string;
    sourceId: string;
    source: string;
    clientOrderId: string;
    customerOrderRef: string;
    orderType: OrderTypeEnum;
    customerId: string;
    wantedDeliveryDate: string;
    creationDate: string;
    note: string;
    externalLabelNote: string;
    status: StatusEnum;
    currency: string;
    paymentMethod: PaymentMethodEnum;
    totalNetAmount: number;
    totalGrossAmount: number;
    paymentTransactionNo: string;
    parcelLockerId: string;
    phone: string;
    email: string;
    orderSource: OrderSourceEnum;
    webShopUser: string;
    webShopUserRef: string;
    invoices: Array<string>;
    invoiceLines: Array<InvoiceLineDto>;
    deliveryNotes: Array<string>;
    deliveryNoteLines: Array<DeliveryNoteDto>;
    deliveryAddressId: string;
    deliveryAddress: DeliveryAddressDto;
    billingAddress: DeliveryAddressDto;
    orderLines: Array<OrderLineDto>;
};

export type OrderLineDto = {
    product?: SilWebProductDto;
    productId: string;
    lineNo?: number;
    relNo?: number;
    quantity: number;
    uom?: string;
    status?: StatusEnum;
    saleUnitPrice?: number;
    netAmount?: number;
    grossAmount?: number;
    taxAmount?: number;
    plannedDeliveryDate?: string;
    deliveredQuantity?: number;
    description?: string;
    traceLinks?: Array<string>;
    demandRefNo?: string;
    demandLineNo?: string;
    demandDeliveryNo?: string;
    demandType?: string;
    originalProductId?: string;
    appropriationId?: string;
};

export type CustomerDataDto = {
    id?: string;
    customerId?: string;
    name?: string;
    email?: string;
    phone?: string;
    paymentMethods?: Array<PaymentMethodEnum>;
    addresses?: Array<CustomerAddressDto>;
};

export type CustomerProfileInfoDto = {
    customerData?: CustomerDataDto;
    userData?: CustomerUserDataDto;
};

export type CustomerUserDataDto = {
    username?: string;
    name?: string;
    email?: string;
    phone?: string;
};

export type CustomerPriceListDto = {
    priceListIds?: Array<string>;
};

export type CustomerAgreementsResponseDto = {
    customerAgreements?: Array<string>;
};

export type CustomerInfoDto = {
    id?: string;
    name?: string;
    type?: string;
};

/**
 * Market header. Allowed values: DK_B2B, DK_B2C, FI_B2B, FI_B2C, NO_B2B, NO_B2C, SE_B2B, SE_B2C
 */
export const CountryMarketEnum = {
    DK_B2B: 'DK_B2B',
    DK_B2C: 'DK_B2C',
    FI_B2B: 'FI_B2B',
    FI_B2C: 'FI_B2C',
    NO_B2B: 'NO_B2B',
    NO_B2C: 'NO_B2C',
    SE_B2B: 'SE_B2B',
    SE_B2C: 'SE_B2C'
} as const;

/**
 * Market header. Allowed values: DK_B2B, DK_B2C, FI_B2B, FI_B2C, NO_B2B, NO_B2C, SE_B2B, SE_B2C
 */
export type CountryMarketEnum = typeof CountryMarketEnum[keyof typeof CountryMarketEnum];

/**
 * Role header. Allowed values: ANONYMOUS, EMPLOYEE, CUSTOMER
 */
export const RoleValueEnum = {
    ANONYMOUS: 'ANONYMOUS',
    EMPLOYEE: 'EMPLOYEE',
    CUSTOMER: 'CUSTOMER'
} as const;

/**
 * Role header. Allowed values: ANONYMOUS, EMPLOYEE, CUSTOMER
 */
export type RoleValueEnum = typeof RoleValueEnum[keyof typeof RoleValueEnum];

export const SchemaEnum = { DK_B2B: 'DK_B2B', DK_B2C: 'DK_B2C' } as const;

export type SchemaEnum = typeof SchemaEnum[keyof typeof SchemaEnum];

/**
 * Type of the image, can be PRIMARY or GALLERY
 */
export const ImageTypeEnum = { PRIMARY: 'PRIMARY', GALLERY: 'GALLERY' } as const;

/**
 * Type of the image, can be PRIMARY or GALLERY
 */
export type ImageTypeEnum = typeof ImageTypeEnum[keyof typeof ImageTypeEnum];

export const SortDirectionEnum = { DESC: 'DESC', ASC: 'ASC' } as const;

export type SortDirectionEnum = typeof SortDirectionEnum[keyof typeof SortDirectionEnum];

/**
 * Type of the price
 */
export const PriceTypeEnum = {
    BUY: 'BUY',
    FROM: 'FROM',
    BASE: 'BASE',
    SCALED: 'SCALED',
    CONTRACT: 'CONTRACT',
    DISCOUNT_NORMAL: 'DISCOUNT_NORMAL',
    DISCOUNT_CAMPAIGN: 'DISCOUNT_CAMPAIGN',
    DISCOUNT_SCALEDCAMPAIGN: 'DISCOUNT_SCALEDCAMPAIGN',
    DISCOUNT_PROMOTION: 'DISCOUNT_PROMOTION'
} as const;

/**
 * Type of the price
 */
export type PriceTypeEnum = typeof PriceTypeEnum[keyof typeof PriceTypeEnum];

export const TypeEnum = { RADIO: 'RADIO', CHECKBOX: 'CHECKBOX' } as const;

export type TypeEnum = typeof TypeEnum[keyof typeof TypeEnum];

export const ProductStockEnum = {
    STOCK_REGULAR_WITHOUT_QUANTITY: 'STOCK_REGULAR_WITHOUT_QUANTITY',
    STOCK_REGULAR_WITH_QUANTITY: 'STOCK_REGULAR_WITH_QUANTITY',
    NON_STOCK_WITHOUT_QUANTITY: 'NON_STOCK_WITHOUT_QUANTITY',
    NON_STOCK_WITH_QUANTITY: 'NON_STOCK_WITH_QUANTITY',
    NON_STOCK_DIRECT_WITH_QUANTITY: 'NON_STOCK_DIRECT_WITH_QUANTITY',
    UNKNOWN: 'UNKNOWN'
} as const;

export type ProductStockEnum = typeof ProductStockEnum[keyof typeof ProductStockEnum];

export const ProductWebshopStatusEnum = {
    COMPOSABLE_A: 'COMPOSABLE_A',
    COMPOSABLE_B: 'COMPOSABLE_B',
    COMPOSABLE_C: 'COMPOSABLE_C',
    COMPOSABLE_D: 'COMPOSABLE_D',
    COMPOSABLE_E: 'COMPOSABLE_E',
    COMPOSABLE_F: 'COMPOSABLE_F',
    COMPOSABLE_G: 'COMPOSABLE_G',
    NO: 'NO'
} as const;

export type ProductWebshopStatusEnum = typeof ProductWebshopStatusEnum[keyof typeof ProductWebshopStatusEnum];

export const ProductPartStatusEnum = {
    A: 'A',
    O: 'O',
    P: 'P',
    D: 'D',
    S: 'S',
    T: 'T',
    N: 'N',
    UNKNOWN: 'UNKNOWN'
} as const;

export type ProductPartStatusEnum = typeof ProductPartStatusEnum[keyof typeof ProductPartStatusEnum];

export const StockLevelStatusEnum = {
    IN_STOCK: 'inStock',
    OUT_OF_STOCK: 'outOfStock',
    LOW_STOCK: 'lowStock',
    BACK_ORDER: 'backOrder',
    PRE_ORDER: 'preOrder',
    NOT_SPECIFIED: 'notSpecified'
} as const;

export type StockLevelStatusEnum = typeof StockLevelStatusEnum[keyof typeof StockLevelStatusEnum];

/**
 * Discount row type
 */
export const DiscountRowTypeEnum = {
    APPROPRIATION: 'APPROPRIATION',
    GREEN_ORDINATION: 'GREEN_ORDINATION',
    AGREEMENT_GROUP: 'AGREEMENT_GROUP',
    CAMPAIGN_PART: 'CAMPAIGN_PART',
    CAMPAIGN_SALES_PROMOTION_PART: 'CAMPAIGN_SALES_PROMOTION_PART',
    CAMPAIGN_SALES_PROMOTION_NODE: 'CAMPAIGN_SALES_PROMOTION_NODE'
} as const;

/**
 * Discount row type
 */
export type DiscountRowTypeEnum = typeof DiscountRowTypeEnum[keyof typeof DiscountRowTypeEnum];

/**
 * Type of price
 */
export const PriceTypeEnum2 = {
    AGREEMENT: 'AGREEMENT',
    AGREEMENT_GROUP: 'AGREEMENT_GROUP',
    APPROPRIATION: 'APPROPRIATION',
    PRICE_LIST: 'PRICE_LIST',
    POSITIVE_LIST: 'POSITIVE_LIST',
    CAMPAIGN: 'CAMPAIGN'
} as const;

/**
 * Type of price
 */
export type PriceTypeEnum2 = typeof PriceTypeEnum2[keyof typeof PriceTypeEnum2];

export const StatusEnum = {
    RELEASED: 'RELEASED',
    BLOCKED: 'BLOCKED',
    RESERVED: 'RESERVED',
    PICKED: 'PICKED',
    PARTIALLY_DELIVERED: 'PARTIALLY_DELIVERED',
    DELIVERED: 'DELIVERED',
    CANCELLED: 'CANCELLED',
    PLANNED: 'PLANNED',
    INVOICED: 'INVOICED',
    CLOSED: 'CLOSED'
} as const;

export type StatusEnum = typeof StatusEnum[keyof typeof StatusEnum];

export const PaymentMethodEnum = {
    INVOICE: 'INVOICE',
    CREDIT_CARD: 'CREDIT_CARD',
    PBS: 'PBS'
} as const;

export type PaymentMethodEnum = typeof PaymentMethodEnum[keyof typeof PaymentMethodEnum];

export const OrderTypeEnum = {
    B2B: 'B2B',
    B2P: 'B2P',
    NO: 'NO'
} as const;

export type OrderTypeEnum = typeof OrderTypeEnum[keyof typeof OrderTypeEnum];

export const OrderSourceEnum = {
    WEBSHOP_DK_B2B: 'WEBSHOP_DK_B2B',
    WEBSHOP_DK_B2C: 'WEBSHOP_DK_B2C',
    WEBSHOP_DK_B2A: 'WEBSHOP_DK_B2A',
    WEBSHOP_NO_B2B: 'WEBSHOP_NO_B2B',
    WEBSHOP_NO_B2C: 'WEBSHOP_NO_B2C',
    WEBSHOP_NO_B2A: 'WEBSHOP_NO_B2A',
    WEBSHOP_SE_B2B: 'WEBSHOP_SE_B2B',
    WEBSHOP_SE_B2C: 'WEBSHOP_SE_B2C',
    WEBSHOP_SE_B2A: 'WEBSHOP_SE_B2A',
    WEBSHOP_FI_B2B: 'WEBSHOP_FI_B2B',
    WEBSHOP_FI_B2C: 'WEBSHOP_FI_B2C',
    WEBSHOP_FI_B2A: 'WEBSHOP_FI_B2A',
    UNKNOWN: 'UNKNOWN'
} as const;

export type OrderSourceEnum = typeof OrderSourceEnum[keyof typeof OrderSourceEnum];

export const CustomerTypeEnum = { CONSUMER: 'CONSUMER', BUSINESS: 'BUSINESS' } as const;

export type CustomerTypeEnum = typeof CustomerTypeEnum[keyof typeof CustomerTypeEnum];

/**
 * Sort option: NAME_ASC, NAME_DESC, CREATED_DATE_ASC, CREATED_DATE_DESC
 */
export const SortByEnum = {
    NAME_ASC: 'NAME_ASC',
    NAME_DESC: 'NAME_DESC',
    CREATED_DATE_ASC: 'CREATED_DATE_ASC',
    CREATED_DATE_DESC: 'CREATED_DATE_DESC'
} as const;

/**
 * Sort option: NAME_ASC, NAME_DESC, CREATED_DATE_ASC, CREATED_DATE_DESC
 */
export type SortByEnum = typeof SortByEnum[keyof typeof SortByEnum];

/**
 * Sort option: NAME_ASC, NAME_DESC, NUMBER_ASC, NUMBER_DESC
 */
export const SortByEnum2 = {
    NAME_ASC: 'NAME_ASC',
    NAME_DESC: 'NAME_DESC',
    NUMBER_ASC: 'NUMBER_ASC',
    NUMBER_DESC: 'NUMBER_DESC'
} as const;

/**
 * Sort option: NAME_ASC, NAME_DESC, NUMBER_ASC, NUMBER_DESC
 */
export type SortByEnum2 = typeof SortByEnum2[keyof typeof SortByEnum2];

export const MethodEnum = { PHONE: 'PHONE', E_MAIL: 'E_MAIL' } as const;

export type MethodEnum = typeof MethodEnum[keyof typeof MethodEnum];

export const PurposeEnum = {
    BILLING: 'BILLING',
    SHIPPING: 'SHIPPING',
    CONTACT: 'CONTACT'
} as const;

export type PurposeEnum = typeof PurposeEnum[keyof typeof PurposeEnum];

export const DefaultAddressTypeEnum = { DEFAULT_BILLING: 'DEFAULT_BILLING', DEFAULT_SHIPPING: 'DEFAULT_SHIPPING' } as const;

export type DefaultAddressTypeEnum = typeof DefaultAddressTypeEnum[keyof typeof DefaultAddressTypeEnum];

export const UseEnum = { TOTAL_VALUE: 'TOTAL_VALUE', UNIT_PRICE: 'UNIT_PRICE' } as const;

export type UseEnum = typeof UseEnum[keyof typeof UseEnum];

export const BusinessTypeEnum = {
    B2A: 'B2A',
    B2B: 'B2B',
    B2C: 'B2C'
} as const;

export type BusinessTypeEnum = typeof BusinessTypeEnum[keyof typeof BusinessTypeEnum];

export const PrescriptionTypeEnum = {
    NUTRITION: 'NUTRITION',
    MISCELLANEOUS: 'MISCELLANEOUS',
    INCONTINENCE: 'INCONTINENCE',
    DIABETES: 'DIABETES',
    DIABETES_TYPE_1: 'DIABETES_TYPE_1',
    DIABETES_TYPE_2: 'DIABETES_TYPE_2',
    OSTOMY: 'OSTOMY',
    RESPIRATORY: 'RESPIRATORY',
    STOCKINGS: 'STOCKINGS',
    DIETARY_SUPPLEMENTS: 'DIETARY_SUPPLEMENTS',
    HALF_NUTRITION: 'HALF_NUTRITION',
    FULL_NUTRITION: 'FULL_NUTRITION',
    GLUTEN_PRODUCT: 'GLUTEN_PRODUCT',
    DEDUCTIBLE: 'DEDUCTIBLE',
    NURSING: 'NURSING',
    ACCESSORIES_NUTRITION: 'ACCESSORIES_NUTRITION',
    CVK: 'CVK',
    UNKNOWN: 'UNKNOWN'
} as const;

export type PrescriptionTypeEnum = typeof PrescriptionTypeEnum[keyof typeof PrescriptionTypeEnum];

export const MediqFlagEnum = {
    APPROPRIATION: 'APPROPRIATION',
    GREEN_ORDINATION: 'GREEN_ORDINATION',
    PROJECT: 'PROJECT',
    EMPTY: 'EMPTY'
} as const;

export type MediqFlagEnum = typeof MediqFlagEnum[keyof typeof MediqFlagEnum];

export const StateEnum = {
    RELEASED: 'RELEASED',
    REVISED: 'REVISED',
    PLANNED: 'PLANNED',
    CANCELLED: 'CANCELLED',
    CLOSED: 'CLOSED',
    REJECTED: 'REJECTED',
    WON: 'WON',
    LOST: 'LOST'
} as const;

export type StateEnum = typeof StateEnum[keyof typeof StateEnum];

export const ProductTypeEnum = { PRODUCT: 'PRODUCT', GROUP: 'GROUP' } as const;

export type ProductTypeEnum = typeof ProductTypeEnum[keyof typeof ProductTypeEnum];

export const PeriodEnum = {
    AS_NEEDED: 'AS_NEEDED',
    DAILY: 'DAILY',
    MONTHLY: 'MONTHLY',
    ONCE: 'ONCE',
    WEEKLY: 'WEEKLY',
    YEARLY: 'YEARLY'
} as const;

export type PeriodEnum = typeof PeriodEnum[keyof typeof PeriodEnum];

export const StatusEnum2 = {
    CLOSED: 'CLOSED',
    PLANNED: 'PLANNED',
    RELEASED: 'RELEASED',
    CUSTOMER_ORDER_CREATED: 'CUSTOMER_ORDER_CREATED',
    CANCELLED: 'CANCELLED',
    REJECTED: 'REJECTED',
    WON: 'WON',
    REVISED: 'REVISED',
    LOST: 'LOST'
} as const;

export type StatusEnum2 = typeof StatusEnum2[keyof typeof StatusEnum2];

export type RemoveProductFromFavoriteListData = {
    body?: never;
    headers?: {
        /**
         * Market header
         */
        'X-Market'?: CountryMarketEnum;
        /**
         * Role header
         */
        'X-Role'?: RoleValueEnum;
        /**
         * Optional customer id used to impersonate or scope requests
         */
        'X-CustomerId'?: string;
        /**
         * Organization Unit header
         */
        'X-OrgUnit'?: string;
    };
    path: {
        favoriteListId: string;
        productId: string;
    };
    query?: never;
    url: '/favoritelist/{favoriteListId}/items/{productId}';
};

export type RemoveProductFromFavoriteListErrors = {
    /**
     * Not found
     */
    404: FavoriteListResponseDto;
    /**
     * Server error
     */
    500: FavoriteListResponseDto;
};

export type RemoveProductFromFavoriteListError = RemoveProductFromFavoriteListErrors[keyof RemoveProductFromFavoriteListErrors];

export type RemoveProductFromFavoriteListResponses = {
    /**
     * Favorite list updated
     */
    200: FavoriteListResponseDto;
};

export type RemoveProductFromFavoriteListResponse = RemoveProductFromFavoriteListResponses[keyof RemoveProductFromFavoriteListResponses];

export type AddProductToFavoriteListData = {
    body?: never;
    headers?: {
        /**
         * Market header
         */
        'X-Market'?: CountryMarketEnum;
        /**
         * Role header
         */
        'X-Role'?: RoleValueEnum;
        /**
         * Optional customer id used to impersonate or scope requests
         */
        'X-CustomerId'?: string;
        /**
         * Organization Unit header
         */
        'X-OrgUnit'?: string;
    };
    path: {
        favoriteListId: string;
        productId: string;
    };
    query?: never;
    url: '/favoritelist/{favoriteListId}/items/{productId}';
};

export type AddProductToFavoriteListErrors = {
    /**
     * Bad request
     */
    400: FavoriteListResponseDto;
    /**
     * Not found
     */
    404: FavoriteListResponseDto;
    /**
     * Server error
     */
    500: FavoriteListResponseDto;
};

export type AddProductToFavoriteListError = AddProductToFavoriteListErrors[keyof AddProductToFavoriteListErrors];

export type AddProductToFavoriteListResponses = {
    /**
     * Favorite list updated
     */
    200: FavoriteListResponseDto;
};

export type AddProductToFavoriteListResponse = AddProductToFavoriteListResponses[keyof AddProductToFavoriteListResponses];

export type UpdateDesiredQuantityData = {
    body: DesiredQuantityRequestDto;
    headers?: {
        /**
         * Market header
         */
        'X-Market'?: CountryMarketEnum;
        /**
         * Role header
         */
        'X-Role'?: RoleValueEnum;
        /**
         * Optional customer id used to impersonate or scope requests
         */
        'X-CustomerId'?: string;
        /**
         * Organization Unit header
         */
        'X-OrgUnit'?: string;
    };
    path: {
        favoriteListId: string;
        productId: string;
    };
    query?: never;
    url: '/favoritelist/{favoriteListId}/items/{productId}';
};

export type UpdateDesiredQuantityErrors = {
    /**
     * Bad request
     */
    400: FavoriteListResponseDto;
    /**
     * Not found
     */
    404: FavoriteListResponseDto;
    /**
     * Server error
     */
    500: FavoriteListResponseDto;
};

export type UpdateDesiredQuantityError = UpdateDesiredQuantityErrors[keyof UpdateDesiredQuantityErrors];

export type UpdateDesiredQuantityResponses = {
    /**
     * Favorite list updated
     */
    200: FavoriteListResponseDto;
};

export type UpdateDesiredQuantityResponse = UpdateDesiredQuantityResponses[keyof UpdateDesiredQuantityResponses];

export type EditFavoriteListData = {
    body: FavoriteListEditRquestDto;
    headers?: {
        /**
         * Market header
         */
        'X-Market'?: CountryMarketEnum;
        /**
         * Role header
         */
        'X-Role'?: RoleValueEnum;
        /**
         * Optional customer id used to impersonate or scope requests
         */
        'X-CustomerId'?: string;
        /**
         * Organization Unit header
         */
        'X-OrgUnit'?: string;
    };
    path: {
        favoriteListId: string;
    };
    query?: never;
    url: '/favoritelist/{favoriteListId}/edit';
};

export type EditFavoriteListErrors = {
    /**
     * Bad request
     */
    400: FavoriteListResponseDto;
    /**
     * Not found
     */
    404: FavoriteListResponseDto;
    /**
     * Server error
     */
    500: FavoriteListResponseDto;
};

export type EditFavoriteListError = EditFavoriteListErrors[keyof EditFavoriteListErrors];

export type EditFavoriteListResponses = {
    /**
     * Favorite list edited
     */
    200: FavoriteListResponseDto;
};

export type EditFavoriteListResponse = EditFavoriteListResponses[keyof EditFavoriteListResponses];

export type ProductSearchData = {
    body: ProductSearchQueryDto;
    headers?: {
        /**
         * Market header
         */
        'X-Market'?: CountryMarketEnum;
        /**
         * Role header
         */
        'X-Role'?: RoleValueEnum;
        /**
         * Optional customer id used to impersonate or scope requests
         */
        'X-CustomerId'?: string;
        /**
         * Organization Unit header
         */
        'X-OrgUnit'?: string;
    };
    path?: never;
    query?: never;
    url: '/products/search';
};

export type ProductSearchErrors = {
    /**
     * Bad Request
     */
    400: ServerMessageDto;
    /**
     * Unauthorized
     */
    401: ServerMessageDto;
    /**
     * Forbidden
     */
    403: ServerMessageDto;
    /**
     * Not Found
     */
    404: ServerMessageDto;
    /**
     * Default response
     */
    default: ServerMessageDto;
};

export type ProductSearchError = ProductSearchErrors[keyof ProductSearchErrors];

export type ProductSearchResponses = {
    /**
     * Product list
     */
    200: ProductSearchResultDto;
};

export type ProductSearchResponse = ProductSearchResponses[keyof ProductSearchResponses];

export type QuickSearchData = {
    body: QuickSearchQueryDto;
    headers?: {
        /**
         * Market header
         */
        'X-Market'?: CountryMarketEnum;
        /**
         * Role header
         */
        'X-Role'?: RoleValueEnum;
        /**
         * Optional customer id used to impersonate or scope requests
         */
        'X-CustomerId'?: string;
        /**
         * Organization Unit header
         */
        'X-OrgUnit'?: string;
    };
    path?: never;
    query?: never;
    url: '/products/quickSearch';
};

export type QuickSearchErrors = {
    /**
     * Bad Request
     */
    400: ServerMessageDto;
    /**
     * Unauthorized
     */
    401: ServerMessageDto;
    /**
     * Forbidden
     */
    403: ServerMessageDto;
    /**
     * Default response
     */
    default: ServerMessageDto;
};

export type QuickSearchError = QuickSearchErrors[keyof QuickSearchErrors];

export type QuickSearchResponses = {
    /**
     * Products and categories
     */
    200: QuickSearchResultDto;
};

export type QuickSearchResponse = QuickSearchResponses[keyof QuickSearchResponses];

export type GetPricesData = {
    body: BffPriceInputDto;
    headers?: {
        /**
         * Market header
         */
        'X-Market'?: CountryMarketEnum;
        /**
         * Role header
         */
        'X-Role'?: RoleValueEnum;
        /**
         * Optional customer id used to impersonate or scope requests
         */
        'X-CustomerId'?: string;
        /**
         * Organization Unit header
         */
        'X-OrgUnit'?: string;
    };
    path?: never;
    query?: never;
    url: '/prices';
};

export type GetPricesErrors = {
    /**
     * Bad Request
     */
    400: ServerMessageDto;
    /**
     * Unauthorized
     */
    401: ServerMessageDto;
    /**
     * Forbidden
     */
    403: ServerMessageDto;
    /**
     * Not Found
     */
    404: ServerMessageDto;
    /**
     * Default response
     */
    default: ServerMessageDto;
};

export type GetPricesError = GetPricesErrors[keyof GetPricesErrors];

export type GetPricesResponses = {
    /**
     * Products prices
     */
    200: ProductsPriceResponseDto;
};

export type GetPricesResponse = GetPricesResponses[keyof GetPricesResponses];

export type GetCustomerOrderHistoryData = {
    body: HistoryQueryDto;
    headers?: {
        /**
         * Market header
         */
        'X-Market'?: CountryMarketEnum;
        /**
         * Role header
         */
        'X-Role'?: RoleValueEnum;
        /**
         * Optional customer id used to impersonate or scope requests
         */
        'X-CustomerId'?: string;
        /**
         * Organization Unit header
         */
        'X-OrgUnit'?: string;
    };
    path?: never;
    query?: never;
    url: '/orders/orderHistory';
};

export type GetCustomerOrderHistoryErrors = {
    /**
     * Bad Request
     */
    400: ServerMessageDto;
    /**
     * Unauthorized
     */
    401: ServerMessageDto;
    /**
     * Forbidden
     */
    403: ServerMessageDto;
    /**
     * Not Found
     */
    404: ServerMessageDto;
    /**
     * Default response
     */
    default: ServerMessageDto;
};

export type GetCustomerOrderHistoryError = GetCustomerOrderHistoryErrors[keyof GetCustomerOrderHistoryErrors];

export type GetCustomerOrderHistoryResponses = {
    /**
     * Order summary list
     */
    200: OrderSummaryListDto;
};

export type GetCustomerOrderHistoryResponse = GetCustomerOrderHistoryResponses[keyof GetCustomerOrderHistoryResponses];

export type CreateOrderData = {
    body: UpsertOrderInputDto;
    headers?: {
        /**
         * Market header
         */
        'X-Market'?: CountryMarketEnum;
        /**
         * Role header
         */
        'X-Role'?: RoleValueEnum;
        /**
         * Optional customer id used to impersonate or scope requests
         */
        'X-CustomerId'?: string;
        /**
         * Organization Unit header
         */
        'X-OrgUnit'?: string;
    };
    path?: never;
    query?: never;
    url: '/orders';
};

export type CreateOrderErrors = {
    /**
     * Bad Request
     */
    400: ServerMessageDto;
    /**
     * Unauthorized
     */
    401: ServerMessageDto;
    /**
     * Forbidden
     */
    403: ServerMessageDto;
    /**
     * Not Found
     */
    404: ServerMessageDto;
    /**
     * Default response
     */
    default: ServerMessageDto;
};

export type CreateOrderError = CreateOrderErrors[keyof CreateOrderErrors];

export type CreateOrderResponses = {
    /**
     * Order created successfully
     */
    201: ServerMessageDto;
};

export type CreateOrderResponse = CreateOrderResponses[keyof CreateOrderResponses];

export type GetMarketingPermissionsData = {
    body?: never;
    headers?: {
        /**
         * Market header
         */
        'X-Market'?: CountryMarketEnum;
        /**
         * Role header
         */
        'X-Role'?: RoleValueEnum;
        /**
         * Optional customer id used to impersonate or scope requests
         */
        'X-CustomerId'?: string;
        /**
         * Organization Unit header
         */
        'X-OrgUnit'?: string;
    };
    path: {
        /**
         * Email
         */
        email: string;
    };
    query?: never;
    url: '/marketing/permissions/{email}';
};

export type GetMarketingPermissionsErrors = {
    /**
     * Bad Request
     */
    400: ServerMessageDto;
    /**
     * Unauthorized
     */
    401: ServerMessageDto;
    /**
     * Forbidden
     */
    403: ServerMessageDto;
    /**
     * Not Found
     */
    404: ServerMessageDto;
    /**
     * Default response
     */
    default: ServerMessageDto;
};

export type GetMarketingPermissionsError = GetMarketingPermissionsErrors[keyof GetMarketingPermissionsErrors];

export type GetMarketingPermissionsResponses = {
    /**
     * Marketing permissions
     */
    200: MarketingPermissionDto;
};

export type GetMarketingPermissionsResponse = GetMarketingPermissionsResponses[keyof GetMarketingPermissionsResponses];

export type UpdateMarketingPermissionsData = {
    body: MarketingPermissionRequestDto;
    headers?: {
        /**
         * Market header
         */
        'X-Market'?: CountryMarketEnum;
        /**
         * Role header
         */
        'X-Role'?: RoleValueEnum;
        /**
         * Optional customer id used to impersonate or scope requests
         */
        'X-CustomerId'?: string;
        /**
         * Organization Unit header
         */
        'X-OrgUnit'?: string;
    };
    path: {
        /**
         * Email
         */
        email: string;
    };
    query?: never;
    url: '/marketing/permissions/{email}';
};

export type UpdateMarketingPermissionsErrors = {
    /**
     * Bad Request
     */
    400: ServerMessageDto;
    /**
     * Unauthorized
     */
    401: ServerMessageDto;
    /**
     * Forbidden
     */
    403: ServerMessageDto;
    /**
     * Not Found
     */
    404: ServerMessageDto;
    /**
     * Default response
     */
    default: ServerMessageDto;
};

export type UpdateMarketingPermissionsError = UpdateMarketingPermissionsErrors[keyof UpdateMarketingPermissionsErrors];

export type UpdateMarketingPermissionsResponses = {
    /**
     * Marketing permissions
     */
    200: MarketingPermissionDto;
};

export type UpdateMarketingPermissionsResponse = UpdateMarketingPermissionsResponses[keyof UpdateMarketingPermissionsResponses];

export type GetFavoriteListIdsData = {
    body?: never;
    headers?: {
        /**
         * Market header
         */
        'X-Market'?: CountryMarketEnum;
        /**
         * Role header
         */
        'X-Role'?: RoleValueEnum;
        /**
         * Optional customer id used to impersonate or scope requests
         */
        'X-CustomerId'?: string;
        /**
         * Organization Unit header
         */
        'X-OrgUnit'?: string;
    };
    path?: never;
    query?: never;
    url: '/favoritelists/ids';
};

export type GetFavoriteListIdsErrors = {
    /**
     * Forbidden
     */
    403: Array<string>;
    /**
     * Server error
     */
    500: Array<string>;
};

export type GetFavoriteListIdsError = GetFavoriteListIdsErrors[keyof GetFavoriteListIdsErrors];

export type GetFavoriteListIdsResponses = {
    /**
     * List of favorite list IDs
     */
    200: Array<string>;
};

export type GetFavoriteListIdsResponse = GetFavoriteListIdsResponses[keyof GetFavoriteListIdsResponses];

export type GetFavoriteListIdsByProductIdsData = {
    body: ProductIdsRequestDto;
    headers?: {
        /**
         * Market header
         */
        'X-Market'?: CountryMarketEnum;
        /**
         * Role header
         */
        'X-Role'?: RoleValueEnum;
        /**
         * Optional customer id used to impersonate or scope requests
         */
        'X-CustomerId'?: string;
        /**
         * Organization Unit header
         */
        'X-OrgUnit'?: string;
    };
    path?: never;
    query?: never;
    url: '/favoritelists/ids';
};

export type GetFavoriteListIdsByProductIdsErrors = {
    /**
     * Bad Request
     */
    400: Array<FavoriteListIdsResponseDto>;
    /**
     * Forbidden
     */
    403: Array<FavoriteListIdsResponseDto>;
    /**
     * Server error
     */
    500: Array<FavoriteListIdsResponseDto>;
};

export type GetFavoriteListIdsByProductIdsError = GetFavoriteListIdsByProductIdsErrors[keyof GetFavoriteListIdsByProductIdsErrors];

export type GetFavoriteListIdsByProductIdsResponses = {
    /**
     * List of product IDs and their associated favorite list IDs
     */
    200: Array<FavoriteListIdsResponseDto>;
};

export type GetFavoriteListIdsByProductIdsResponse = GetFavoriteListIdsByProductIdsResponses[keyof GetFavoriteListIdsByProductIdsResponses];

export type GetFavoriteListsData = {
    body: FavoriteListsSearchQueryDto;
    headers?: {
        /**
         * Market header
         */
        'X-Market'?: CountryMarketEnum;
        /**
         * Role header
         */
        'X-Role'?: RoleValueEnum;
        /**
         * Optional customer id used to impersonate or scope requests
         */
        'X-CustomerId'?: string;
        /**
         * Organization Unit header
         */
        'X-OrgUnit'?: string;
    };
    path?: never;
    query?: never;
    url: '/favoritelists';
};

export type GetFavoriteListsErrors = {
    /**
     * Forbidden
     */
    403: FavoriteListsListDto;
    /**
     * Server error
     */
    500: FavoriteListsListDto;
};

export type GetFavoriteListsError = GetFavoriteListsErrors[keyof GetFavoriteListsErrors];

export type GetFavoriteListsResponses = {
    /**
     * List of favorite lists with pagination metadata
     */
    200: FavoriteListsListDto;
};

export type GetFavoriteListsResponse = GetFavoriteListsResponses[keyof GetFavoriteListsResponses];

export type AddProductsToFavoriteListData = {
    body: ProductIdsRequestDto;
    headers?: {
        /**
         * Market header
         */
        'X-Market'?: CountryMarketEnum;
        /**
         * Role header
         */
        'X-Role'?: RoleValueEnum;
        /**
         * Optional customer id used to impersonate or scope requests
         */
        'X-CustomerId'?: string;
        /**
         * Organization Unit header
         */
        'X-OrgUnit'?: string;
    };
    path: {
        favoriteListId: string;
    };
    query?: never;
    url: '/favoritelist/{favoriteListId}/items';
};

export type AddProductsToFavoriteListErrors = {
    /**
     * Bad request
     */
    400: FavoriteListResponseDto;
    /**
     * Not found
     */
    404: FavoriteListResponseDto;
    /**
     * Server error
     */
    500: FavoriteListResponseDto;
};

export type AddProductsToFavoriteListError = AddProductsToFavoriteListErrors[keyof AddProductsToFavoriteListErrors];

export type AddProductsToFavoriteListResponses = {
    /**
     * Favorite list updated
     */
    200: FavoriteListResponseDto;
};

export type AddProductsToFavoriteListResponse = AddProductsToFavoriteListResponses[keyof AddProductsToFavoriteListResponses];

export type GetFavoriteListFullData = {
    body: FavoriteListFullSearchQueryDto;
    headers?: {
        /**
         * Market header
         */
        'X-Market'?: CountryMarketEnum;
        /**
         * Role header
         */
        'X-Role'?: RoleValueEnum;
        /**
         * Optional customer id used to impersonate or scope requests
         */
        'X-CustomerId'?: string;
        /**
         * Organization Unit header
         */
        'X-OrgUnit'?: string;
    };
    path: {
        favoriteListId: string;
    };
    query?: never;
    url: '/favoritelist/{favoriteListId}/full';
};

export type GetFavoriteListFullErrors = {
    /**
     * Bad request
     */
    400: FavoriteListResponseFullDto;
    /**
     * Not found
     */
    404: FavoriteListResponseFullDto;
    /**
     * Server error
     */
    500: FavoriteListResponseFullDto;
};

export type GetFavoriteListFullError = GetFavoriteListFullErrors[keyof GetFavoriteListFullErrors];

export type GetFavoriteListFullResponses = {
    /**
     * Favorite list with products
     */
    200: FavoriteListResponseFullDto;
};

export type GetFavoriteListFullResponse = GetFavoriteListFullResponses[keyof GetFavoriteListFullResponses];

export type CopyFavoriteListData = {
    body?: never;
    headers?: {
        /**
         * Market header
         */
        'X-Market'?: CountryMarketEnum;
        /**
         * Role header
         */
        'X-Role'?: RoleValueEnum;
        /**
         * Optional customer id used to impersonate or scope requests
         */
        'X-CustomerId'?: string;
        /**
         * Organization Unit header
         */
        'X-OrgUnit'?: string;
    };
    path: {
        favoriteListId: string;
    };
    query?: never;
    url: '/favoritelist/{favoriteListId}/copy';
};

export type CopyFavoriteListErrors = {
    /**
     * Source list not found
     */
    404: FavoriteListResponseDto;
    /**
     * Server error
     */
    500: FavoriteListResponseDto;
};

export type CopyFavoriteListError = CopyFavoriteListErrors[keyof CopyFavoriteListErrors];

export type CopyFavoriteListResponses = {
    /**
     * Favorite list copied
     */
    201: FavoriteListResponseDto;
};

export type CopyFavoriteListResponse = CopyFavoriteListResponses[keyof CopyFavoriteListResponses];

export type AddProductToDefaultFavoriteListData = {
    body?: never;
    headers?: {
        /**
         * Market header
         */
        'X-Market'?: CountryMarketEnum;
        /**
         * Role header
         */
        'X-Role'?: RoleValueEnum;
        /**
         * Optional customer id used to impersonate or scope requests
         */
        'X-CustomerId'?: string;
        /**
         * Organization Unit header
         */
        'X-OrgUnit'?: string;
    };
    path: {
        productId: string;
    };
    query?: never;
    url: '/favoritelist/items/{productId}';
};

export type AddProductToDefaultFavoriteListErrors = {
    /**
     * Bad request
     */
    400: FavoriteListResponseDto;
    /**
     * Not found
     */
    404: FavoriteListResponseDto;
    /**
     * Server error
     */
    500: FavoriteListResponseDto;
};

export type AddProductToDefaultFavoriteListError = AddProductToDefaultFavoriteListErrors[keyof AddProductToDefaultFavoriteListErrors];

export type AddProductToDefaultFavoriteListResponses = {
    /**
     * Favorite list updated
     */
    200: FavoriteListResponseDto;
};

export type AddProductToDefaultFavoriteListResponse = AddProductToDefaultFavoriteListResponses[keyof AddProductToDefaultFavoriteListResponses];

export type AddProductsToDefaultFavoriteListData = {
    body: ProductIdsRequestDto;
    headers?: {
        /**
         * Market header
         */
        'X-Market'?: CountryMarketEnum;
        /**
         * Role header
         */
        'X-Role'?: RoleValueEnum;
        /**
         * Optional customer id used to impersonate or scope requests
         */
        'X-CustomerId'?: string;
        /**
         * Organization Unit header
         */
        'X-OrgUnit'?: string;
    };
    path?: never;
    query?: never;
    url: '/favoritelist/items';
};

export type AddProductsToDefaultFavoriteListErrors = {
    /**
     * Bad request
     */
    400: FavoriteListResponseDto;
    /**
     * Not found
     */
    404: FavoriteListResponseDto;
    /**
     * Server error
     */
    500: FavoriteListResponseDto;
};

export type AddProductsToDefaultFavoriteListError = AddProductsToDefaultFavoriteListErrors[keyof AddProductsToDefaultFavoriteListErrors];

export type AddProductsToDefaultFavoriteListResponses = {
    /**
     * Favorite list updated
     */
    200: FavoriteListResponseDto;
};

export type AddProductsToDefaultFavoriteListResponse = AddProductsToDefaultFavoriteListResponses[keyof AddProductsToDefaultFavoriteListResponses];

export type GetDefaultFavoriteListData = {
    body?: never;
    headers?: {
        /**
         * Market header
         */
        'X-Market'?: CountryMarketEnum;
        /**
         * Role header
         */
        'X-Role'?: RoleValueEnum;
        /**
         * Optional customer id used to impersonate or scope requests
         */
        'X-CustomerId'?: string;
        /**
         * Organization Unit header
         */
        'X-OrgUnit'?: string;
    };
    path?: never;
    query?: never;
    url: '/favoritelist';
};

export type GetDefaultFavoriteListErrors = {
    /**
     * Not found
     */
    404: FavoriteListResponseDto;
    /**
     * Server error
     */
    500: FavoriteListResponseDto;
};

export type GetDefaultFavoriteListError = GetDefaultFavoriteListErrors[keyof GetDefaultFavoriteListErrors];

export type GetDefaultFavoriteListResponses = {
    /**
     * Default favorite list
     */
    200: FavoriteListResponseDto;
};

export type GetDefaultFavoriteListResponse = GetDefaultFavoriteListResponses[keyof GetDefaultFavoriteListResponses];

export type CreateFavoriteListData = {
    body: FavoriteListCreateRequestDto;
    headers?: {
        /**
         * Market header
         */
        'X-Market'?: CountryMarketEnum;
        /**
         * Role header
         */
        'X-Role'?: RoleValueEnum;
        /**
         * Optional customer id used to impersonate or scope requests
         */
        'X-CustomerId'?: string;
        /**
         * Organization Unit header
         */
        'X-OrgUnit'?: string;
    };
    path?: never;
    query?: never;
    url: '/favoritelist';
};

export type CreateFavoriteListErrors = {
    /**
     * Bad request
     */
    400: FavoriteListResponseDto;
    /**
     * Server error
     */
    500: FavoriteListResponseDto;
};

export type CreateFavoriteListError = CreateFavoriteListErrors[keyof CreateFavoriteListErrors];

export type CreateFavoriteListResponses = {
    /**
     * Favorite list created
     */
    201: FavoriteListResponseDto;
};

export type CreateFavoriteListResponse = CreateFavoriteListResponses[keyof CreateFavoriteListResponses];

export type UpdateCustomerAddressData = {
    body: CustomerAddressInputDto;
    headers?: {
        /**
         * Market header
         */
        'X-Market'?: CountryMarketEnum;
        /**
         * Role header
         */
        'X-Role'?: RoleValueEnum;
        /**
         * Optional customer id used to impersonate or scope requests
         */
        'X-CustomerId'?: string;
        /**
         * Organization Unit header
         */
        'X-OrgUnit'?: string;
    };
    path?: never;
    query?: never;
    url: '/customers/updateAddress';
};

export type UpdateCustomerAddressErrors = {
    /**
     * Bad Request
     */
    400: ServerMessageDto;
    /**
     * Unauthorized
     */
    401: ServerMessageDto;
    /**
     * Forbidden
     */
    403: ServerMessageDto;
    /**
     * Not Found
     */
    404: ServerMessageDto;
    /**
     * Default response
     */
    default: ServerMessageDto;
};

export type UpdateCustomerAddressError = UpdateCustomerAddressErrors[keyof UpdateCustomerAddressErrors];

export type UpdateCustomerAddressResponses = {
    /**
     * Customer address updated successfully
     */
    201: CustomerAddressesResponseDto;
};

export type UpdateCustomerAddressResponse = UpdateCustomerAddressResponses[keyof UpdateCustomerAddressResponses];

export type GetCustomerAddressesData = {
    body: CustomerAddressesQueryDto;
    headers?: {
        /**
         * Market header
         */
        'X-Market'?: CountryMarketEnum;
        /**
         * Role header
         */
        'X-Role'?: RoleValueEnum;
        /**
         * Optional customer id used to impersonate or scope requests
         */
        'X-CustomerId'?: string;
        /**
         * Organization Unit header
         */
        'X-OrgUnit'?: string;
    };
    path?: never;
    query?: never;
    url: '/customers/addresses';
};

export type GetCustomerAddressesErrors = {
    /**
     * Bad Request
     */
    400: ServerMessageDto;
    /**
     * Unauthorized
     */
    401: ServerMessageDto;
    /**
     * Forbidden
     */
    403: ServerMessageDto;
    /**
     * Not Found
     */
    404: ServerMessageDto;
    /**
     * Default response
     */
    default: ServerMessageDto;
};

export type GetCustomerAddressesError = GetCustomerAddressesErrors[keyof GetCustomerAddressesErrors];

export type GetCustomerAddressesResponses = {
    /**
     * Information about customer
     */
    200: CustomerAddressesResponseDto;
};

export type GetCustomerAddressesResponse = GetCustomerAddressesResponses[keyof GetCustomerAddressesResponses];

export type CalculateCartData = {
    body: CalculateCartInputDto;
    headers?: {
        /**
         * Market header
         */
        'X-Market'?: CountryMarketEnum;
        /**
         * Role header
         */
        'X-Role'?: RoleValueEnum;
        /**
         * Optional customer id used to impersonate or scope requests
         */
        'X-CustomerId'?: string;
        /**
         * Organization Unit header
         */
        'X-OrgUnit'?: string;
    };
    path?: never;
    query?: never;
    url: '/cart';
};

export type CalculateCartErrors = {
    /**
     * Bad Request
     */
    400: ServerMessageDto;
    /**
     * Unauthorized
     */
    401: ServerMessageDto;
    /**
     * Forbidden
     */
    403: ServerMessageDto;
    /**
     * Not Found
     */
    404: ServerMessageDto;
    /**
     * Default response
     */
    default: ServerMessageDto;
};

export type CalculateCartError = CalculateCartErrors[keyof CalculateCartErrors];

export type CalculateCartResponses = {
    /**
     * Calculated cart
     */
    200: CalculateCartResponseDto;
};

export type CalculateCartResponse = CalculateCartResponses[keyof CalculateCartResponses];

export type SearchAppropriationsData = {
    body: AppropriationSearchRequestDto;
    headers?: {
        /**
         * Market header
         */
        'X-Market'?: CountryMarketEnum;
        /**
         * Role header
         */
        'X-Role'?: RoleValueEnum;
        /**
         * Optional customer id used to impersonate or scope requests
         */
        'X-CustomerId'?: string;
        /**
         * Organization Unit header
         */
        'X-OrgUnit'?: string;
    };
    path?: never;
    query?: never;
    url: '/appropriations/search';
};

export type SearchAppropriationsErrors = {
    /**
     * Bad Request
     */
    400: ServerMessageDto;
    /**
     * Unauthorized
     */
    401: ServerMessageDto;
    /**
     * Forbidden
     */
    403: ServerMessageDto;
    /**
     * Not Found
     */
    404: ServerMessageDto;
    /**
     * Default response
     */
    default: ServerMessageDto;
};

export type SearchAppropriationsError = SearchAppropriationsErrors[keyof SearchAppropriationsErrors];

export type SearchAppropriationsResponses = {
    /**
     * Appropriations list
     */
    200: AppropriationListDto;
};

export type SearchAppropriationsResponse = SearchAppropriationsResponses[keyof SearchAppropriationsResponses];

export type ContractedProductSearchData = {
    body: ProductSearchQueryDto;
    headers?: {
        /**
         * Market header
         */
        'X-Market'?: CountryMarketEnum;
        /**
         * Role header
         */
        'X-Role'?: RoleValueEnum;
        /**
         * Optional customer id used to impersonate or scope requests
         */
        'X-CustomerId'?: string;
        /**
         * Organization Unit header
         */
        'X-OrgUnit'?: string;
    };
    path?: never;
    query?: never;
    url: '/agreements/products/search';
};

export type ContractedProductSearchErrors = {
    /**
     * Bad Request
     */
    400: ServerMessageDto;
    /**
     * Unauthorized
     */
    401: ServerMessageDto;
    /**
     * Forbidden
     */
    403: ServerMessageDto;
    /**
     * Not Found
     */
    404: ServerMessageDto;
    /**
     * Default response
     */
    default: ServerMessageDto;
};

export type ContractedProductSearchError = ContractedProductSearchErrors[keyof ContractedProductSearchErrors];

export type ContractedProductSearchResponses = {
    /**
     * Product list
     */
    200: ProductSearchResultDto;
};

export type ContractedProductSearchResponse = ContractedProductSearchResponses[keyof ContractedProductSearchResponses];

export type GetCustomerPositiveListData = {
    body: PositiveListSearchQueryDto;
    headers?: {
        /**
         * Market header
         */
        'X-Market'?: CountryMarketEnum;
        /**
         * Role header
         */
        'X-Role'?: RoleValueEnum;
        /**
         * Optional customer id used to impersonate or scope requests
         */
        'X-CustomerId'?: string;
        /**
         * Organization Unit header
         */
        'X-OrgUnit'?: string;
    };
    path?: never;
    query?: never;
    url: '/agreements/positiveList';
};

export type GetCustomerPositiveListErrors = {
    /**
     * Bad Request
     */
    400: ServerMessageDto;
    /**
     * Unauthorized
     */
    401: ServerMessageDto;
    /**
     * Forbidden
     */
    403: ServerMessageDto;
    /**
     * Not Found
     */
    404: ServerMessageDto;
    /**
     * Default response
     */
    default: ServerMessageDto;
};

export type GetCustomerPositiveListError = GetCustomerPositiveListErrors[keyof GetCustomerPositiveListErrors];

export type GetCustomerPositiveListResponses = {
    /**
     * Agreements list
     */
    200: PositiveListResponseDto;
};

export type GetCustomerPositiveListResponse = GetCustomerPositiveListResponses[keyof GetCustomerPositiveListResponses];

export type GetCurrentUserData = {
    body?: never;
    headers?: {
        /**
         * Market header
         */
        'X-Market'?: CountryMarketEnum;
        /**
         * Role header
         */
        'X-Role'?: RoleValueEnum;
        /**
         * Optional customer id used to impersonate or scope requests
         */
        'X-CustomerId'?: string;
        /**
         * Organization Unit header
         */
        'X-OrgUnit'?: string;
    };
    path?: never;
    query?: never;
    url: '/users/current';
};

export type GetCurrentUserErrors = {
    /**
     * Unauthorized
     */
    401: ServerMessageDto;
    /**
     * Forbidden
     */
    403: ServerMessageDto;
    /**
     * Not Found
     */
    404: ServerMessageDto;
    /**
     * Default response
     */
    default: ServerMessageDto;
};

export type GetCurrentUserError = GetCurrentUserErrors[keyof GetCurrentUserErrors];

export type GetCurrentUserResponses = {
    /**
     * Information about current user
     */
    200: UserInfoDto;
};

export type GetCurrentUserResponse = GetCurrentUserResponses[keyof GetCurrentUserResponses];

export type GetB2bUserData = {
    body?: never;
    headers?: {
        /**
         * Market header
         */
        'X-Market'?: CountryMarketEnum;
        /**
         * Role header
         */
        'X-Role'?: RoleValueEnum;
        /**
         * Optional customer id used to impersonate or scope requests
         */
        'X-CustomerId'?: string;
        /**
         * Organization Unit header
         */
        'X-OrgUnit'?: string;
    };
    path: {
        /**
         * B2B User id
         */
        userId: string;
    };
    query?: never;
    url: '/users/b2b/{userId}';
};

export type GetB2bUserErrors = {
    /**
     * Unauthorized
     */
    401: ServerMessageDto;
    /**
     * Forbidden
     */
    403: ServerMessageDto;
    /**
     * Not Found
     */
    404: ServerMessageDto;
    /**
     * Default response
     */
    default: ServerMessageDto;
};

export type GetB2bUserError = GetB2bUserErrors[keyof GetB2bUserErrors];

export type GetB2bUserResponses = {
    /**
     * Information about user
     */
    200: UserInfoDto;
};

export type GetB2bUserResponse = GetB2bUserResponses[keyof GetB2bUserResponses];

export type UserInfoData = {
    body?: never;
    headers?: {
        /**
         * Market header
         */
        'X-Market'?: CountryMarketEnum;
        /**
         * Role header
         */
        'X-Role'?: RoleValueEnum;
        /**
         * Optional customer id used to impersonate or scope requests
         */
        'X-CustomerId'?: string;
        /**
         * Organization Unit header
         */
        'X-OrgUnit'?: string;
    };
    path?: never;
    query?: never;
    url: '/user-info';
};

export type UserInfoResponses = {
    /**
     * OK
     */
    200: {
        [key: string]: unknown;
    };
};

export type UserInfoResponse = UserInfoResponses[keyof UserInfoResponses];

export type GetAnonymousTokenData = {
    body?: never;
    headers?: {
        /**
         * Market header
         */
        'X-Market'?: CountryMarketEnum;
        /**
         * Role header
         */
        'X-Role'?: RoleValueEnum;
        /**
         * Optional customer id used to impersonate or scope requests
         */
        'X-CustomerId'?: string;
        /**
         * Organization Unit header
         */
        'X-OrgUnit'?: string;
    };
    path?: never;
    query?: never;
    url: '/token';
};

export type GetAnonymousTokenErrors = {
    /**
     * Bad Request
     */
    400: ServerMessageDto;
    /**
     * Forbidden
     */
    403: ServerMessageDto;
    /**
     * Not Found
     */
    404: ServerMessageDto;
    /**
     * Default response
     */
    default: ServerMessageDto;
};

export type GetAnonymousTokenError = GetAnonymousTokenErrors[keyof GetAnonymousTokenErrors];

export type GetAnonymousTokenResponses = {
    /**
     * Anonymous token
     */
    200: AnonymousTokenResponseDto;
};

export type GetAnonymousTokenResponse = GetAnonymousTokenResponses[keyof GetAnonymousTokenResponses];

export type PublicHelloData = {
    body?: never;
    headers?: {
        /**
         * Market header
         */
        'X-Market'?: CountryMarketEnum;
        /**
         * Role header
         */
        'X-Role'?: RoleValueEnum;
        /**
         * Optional customer id used to impersonate or scope requests
         */
        'X-CustomerId'?: string;
        /**
         * Organization Unit header
         */
        'X-OrgUnit'?: string;
    };
    path?: never;
    query?: never;
    url: '/public/hello';
};

export type PublicHelloResponses = {
    /**
     * OK
     */
    200: string;
};

export type PublicHelloResponse = PublicHelloResponses[keyof PublicHelloResponses];

export type GetOrderInvoicesAsZipData = {
    body?: never;
    headers?: {
        /**
         * Market header
         */
        'X-Market'?: CountryMarketEnum;
        /**
         * Role header
         */
        'X-Role'?: RoleValueEnum;
        /**
         * Optional customer id used to impersonate or scope requests
         */
        'X-CustomerId'?: string;
        /**
         * Organization Unit header
         */
        'X-OrgUnit'?: string;
    };
    path: {
        id: string;
    };
    query?: never;
    url: '/orders/{id}/invoices';
};

export type GetOrderInvoicesAsZipErrors = {
    /**
     * Unauthorized
     */
    401: ServerMessageDto;
    /**
     * Forbidden
     */
    403: ServerMessageDto;
    /**
     * Not Found
     */
    404: ServerMessageDto;
    /**
     * default response
     */
    default: ServerMessageDto;
};

export type GetOrderInvoicesAsZipError = GetOrderInvoicesAsZipErrors[keyof GetOrderInvoicesAsZipErrors];

export type GetOrderInvoicesAsZipResponses = {
    /**
     * Successfully generated ZIP file
     */
    200: Blob | File;
};

export type GetOrderInvoicesAsZipResponse = GetOrderInvoicesAsZipResponses[keyof GetOrderInvoicesAsZipResponses];

export type GetOrderDeliveryNotesAsZipData = {
    body?: never;
    headers?: {
        /**
         * Market header
         */
        'X-Market'?: CountryMarketEnum;
        /**
         * Role header
         */
        'X-Role'?: RoleValueEnum;
        /**
         * Optional customer id used to impersonate or scope requests
         */
        'X-CustomerId'?: string;
        /**
         * Organization Unit header
         */
        'X-OrgUnit'?: string;
    };
    path: {
        id: string;
    };
    query?: never;
    url: '/orders/{id}/deliveryNotes';
};

export type GetOrderDeliveryNotesAsZipErrors = {
    /**
     * Unauthorized
     */
    401: ServerMessageDto;
    /**
     * Forbidden
     */
    403: ServerMessageDto;
    /**
     * Not Found
     */
    404: ServerMessageDto;
    /**
     * default response
     */
    default: ServerMessageDto;
};

export type GetOrderDeliveryNotesAsZipError = GetOrderDeliveryNotesAsZipErrors[keyof GetOrderDeliveryNotesAsZipErrors];

export type GetOrderDeliveryNotesAsZipResponses = {
    /**
     * Successfully generated ZIP file
     */
    200: Blob | File;
};

export type GetOrderDeliveryNotesAsZipResponse = GetOrderDeliveryNotesAsZipResponses[keyof GetOrderDeliveryNotesAsZipResponses];

export type GetOrderData = {
    body?: never;
    headers?: {
        /**
         * Market header
         */
        'X-Market'?: CountryMarketEnum;
        /**
         * Role header
         */
        'X-Role'?: RoleValueEnum;
        /**
         * Optional customer id used to impersonate or scope requests
         */
        'X-CustomerId'?: string;
        /**
         * Organization Unit header
         */
        'X-OrgUnit'?: string;
    };
    path: {
        id: string;
    };
    query?: never;
    url: '/orders/{id}';
};

export type GetOrderErrors = {
    /**
     * Unauthorized
     */
    401: ServerMessageDto;
    /**
     * Forbidden
     */
    403: ServerMessageDto;
    /**
     * Not Found
     */
    404: ServerMessageDto;
    /**
     * Default response
     */
    default: ServerMessageDto;
};

export type GetOrderError = GetOrderErrors[keyof GetOrderErrors];

export type GetOrderResponses = {
    /**
     * Order
     */
    200: OrderDto;
};

export type GetOrderResponse = GetOrderResponses[keyof GetOrderResponses];

export type HelloData = {
    body?: never;
    headers?: {
        /**
         * Market header
         */
        'X-Market'?: CountryMarketEnum;
        /**
         * Role header
         */
        'X-Role'?: RoleValueEnum;
        /**
         * Optional customer id used to impersonate or scope requests
         */
        'X-CustomerId'?: string;
        /**
         * Organization Unit header
         */
        'X-OrgUnit'?: string;
    };
    path?: never;
    query?: never;
    url: '/hello';
};

export type HelloResponses = {
    /**
     * OK
     */
    200: string;
};

export type HelloResponse = HelloResponses[keyof HelloResponses];

export type GetFavoriteListIdsByProductIdData = {
    body?: never;
    headers?: {
        /**
         * Market header
         */
        'X-Market'?: CountryMarketEnum;
        /**
         * Role header
         */
        'X-Role'?: RoleValueEnum;
        /**
         * Optional customer id used to impersonate or scope requests
         */
        'X-CustomerId'?: string;
        /**
         * Organization Unit header
         */
        'X-OrgUnit'?: string;
    };
    path: {
        /**
         * The product ID to search for in favorite lists
         */
        productId: string;
    };
    query?: never;
    url: '/favoritelists/ids/{productId}';
};

export type GetFavoriteListIdsByProductIdErrors = {
    /**
     * Bad Request
     */
    400: Array<string>;
    /**
     * Forbidden
     */
    403: Array<string>;
    /**
     * Server error
     */
    500: Array<string>;
};

export type GetFavoriteListIdsByProductIdError = GetFavoriteListIdsByProductIdErrors[keyof GetFavoriteListIdsByProductIdErrors];

export type GetFavoriteListIdsByProductIdResponses = {
    /**
     * List of favorite list IDs
     */
    200: Array<string>;
};

export type GetFavoriteListIdsByProductIdResponse = GetFavoriteListIdsByProductIdResponses[keyof GetFavoriteListIdsByProductIdResponses];

export type DeleteFavoriteListData = {
    body?: never;
    headers?: {
        /**
         * Market header
         */
        'X-Market'?: CountryMarketEnum;
        /**
         * Role header
         */
        'X-Role'?: RoleValueEnum;
        /**
         * Optional customer id used to impersonate or scope requests
         */
        'X-CustomerId'?: string;
        /**
         * Organization Unit header
         */
        'X-OrgUnit'?: string;
    };
    path: {
        favoriteListId: string;
    };
    query?: never;
    url: '/favoritelist/{favoriteListId}';
};

export type DeleteFavoriteListErrors = {
    /**
     * Bad request
     */
    400: unknown;
    /**
     * Not found
     */
    404: unknown;
    /**
     * Server error
     */
    500: unknown;
};

export type DeleteFavoriteListResponses = {
    /**
     * Deleted
     */
    204: void;
};

export type DeleteFavoriteListResponse = DeleteFavoriteListResponses[keyof DeleteFavoriteListResponses];

export type GetFavoriteListData = {
    body?: never;
    headers?: {
        /**
         * Market header
         */
        'X-Market'?: CountryMarketEnum;
        /**
         * Role header
         */
        'X-Role'?: RoleValueEnum;
        /**
         * Optional customer id used to impersonate or scope requests
         */
        'X-CustomerId'?: string;
        /**
         * Organization Unit header
         */
        'X-OrgUnit'?: string;
    };
    path: {
        favoriteListId: string;
    };
    query?: never;
    url: '/favoritelist/{favoriteListId}';
};

export type GetFavoriteListErrors = {
    /**
     * Bad request
     */
    400: FavoriteListResponseDto;
    /**
     * Not found
     */
    404: FavoriteListResponseDto;
    /**
     * Server error
     */
    500: FavoriteListResponseDto;
};

export type GetFavoriteListError = GetFavoriteListErrors[keyof GetFavoriteListErrors];

export type GetFavoriteListResponses = {
    /**
     * Favorite list
     */
    200: FavoriteListResponseDto;
};

export type GetFavoriteListResponse = GetFavoriteListResponses[keyof GetFavoriteListResponses];

export type GetCustomerProfileData = {
    body?: never;
    headers?: {
        /**
         * Market header
         */
        'X-Market'?: CountryMarketEnum;
        /**
         * Role header
         */
        'X-Role'?: RoleValueEnum;
        /**
         * Optional customer id used to impersonate or scope requests
         */
        'X-CustomerId'?: string;
        /**
         * Organization Unit header
         */
        'X-OrgUnit'?: string;
    };
    path?: never;
    query?: never;
    url: '/customers/profile';
};

export type GetCustomerProfileErrors = {
    /**
     * Unauthorized
     */
    401: ServerMessageDto;
    /**
     * Forbidden
     */
    403: ServerMessageDto;
    /**
     * Not Found
     */
    404: ServerMessageDto;
    /**
     * Default response
     */
    default: ServerMessageDto;
};

export type GetCustomerProfileError = GetCustomerProfileErrors[keyof GetCustomerProfileErrors];

export type GetCustomerProfileResponses = {
    /**
     * Information about customer
     */
    200: CustomerProfileInfoDto;
};

export type GetCustomerProfileResponse = GetCustomerProfileResponses[keyof GetCustomerProfileResponses];

export type GetCustomerPriceListsData = {
    body?: never;
    headers?: {
        /**
         * Market header
         */
        'X-Market'?: CountryMarketEnum;
        /**
         * Role header
         */
        'X-Role'?: RoleValueEnum;
        /**
         * Optional customer id used to impersonate or scope requests
         */
        'X-CustomerId'?: string;
        /**
         * Organization Unit header
         */
        'X-OrgUnit'?: string;
    };
    path?: never;
    query?: never;
    url: '/customers/current/priceLists';
};

export type GetCustomerPriceListsErrors = {
    /**
     * Unauthorized
     */
    401: ServerMessageDto;
    /**
     * Forbidden
     */
    403: ServerMessageDto;
    /**
     * Not Found
     */
    404: ServerMessageDto;
    /**
     * Default response
     */
    default: ServerMessageDto;
};

export type GetCustomerPriceListsError = GetCustomerPriceListsErrors[keyof GetCustomerPriceListsErrors];

export type GetCustomerPriceListsResponses = {
    /**
     * Agreements list
     */
    200: CustomerPriceListDto;
};

export type GetCustomerPriceListsResponse = GetCustomerPriceListsResponses[keyof GetCustomerPriceListsResponses];

export type GetCustomerAgreementsData = {
    body?: never;
    headers?: {
        /**
         * Market header
         */
        'X-Market'?: CountryMarketEnum;
        /**
         * Role header
         */
        'X-Role'?: RoleValueEnum;
        /**
         * Optional customer id used to impersonate or scope requests
         */
        'X-CustomerId'?: string;
        /**
         * Organization Unit header
         */
        'X-OrgUnit'?: string;
    };
    path?: never;
    query?: never;
    url: '/customers/current/agreements';
};

export type GetCustomerAgreementsErrors = {
    /**
     * Unauthorized
     */
    401: ServerMessageDto;
    /**
     * Forbidden
     */
    403: ServerMessageDto;
    /**
     * Not Found
     */
    404: ServerMessageDto;
    /**
     * Default response
     */
    default: ServerMessageDto;
};

export type GetCustomerAgreementsError = GetCustomerAgreementsErrors[keyof GetCustomerAgreementsErrors];

export type GetCustomerAgreementsResponses = {
    /**
     * Agreements list
     */
    200: CustomerAgreementsResponseDto;
};

export type GetCustomerAgreementsResponse = GetCustomerAgreementsResponses[keyof GetCustomerAgreementsResponses];

export type GetCustomerByIdData = {
    body?: never;
    headers?: {
        /**
         * Market header
         */
        'X-Market'?: CountryMarketEnum;
        /**
         * Role header
         */
        'X-Role'?: RoleValueEnum;
        /**
         * Optional customer id used to impersonate or scope requests
         */
        'X-CustomerId'?: string;
        /**
         * Organization Unit header
         */
        'X-OrgUnit'?: string;
    };
    path?: never;
    query?: never;
    url: '/customers/current';
};

export type GetCustomerByIdErrors = {
    /**
     * Unauthorized
     */
    401: ServerMessageDto;
    /**
     * Forbidden
     */
    403: ServerMessageDto;
    /**
     * Not Found
     */
    404: ServerMessageDto;
    /**
     * Default response
     */
    default: ServerMessageDto;
};

export type GetCustomerByIdError = GetCustomerByIdErrors[keyof GetCustomerByIdErrors];

export type GetCustomerByIdResponses = {
    /**
     * Information about customer
     */
    200: CustomerInfoDto;
};

export type GetCustomerByIdResponse = GetCustomerByIdResponses[keyof GetCustomerByIdResponses];
